import {useCallback, useEffect, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import Logger from '@nl/logger';
import {loadScript, loadScripts} from '../utils/utils';
import {event, EVENT_TYPES} from '../utils/event';

const useAdInitialization = () => {
	const {
		enabled,
		WMUserConsentConfig,
		WMUserConsentLibrary,
		target,
		libraries,
		country,
	} = useSelector((state) => ({
		enabled: state.config.data.AD_FUEL.enabled,
		WMUserConsentConfig: state.config.data.AD_FUEL.WMUserConsentConfig,
		WMUserConsentLibrary: state.config.data.AD_FUEL.WMUserConsentLibrary,
		target: state.config.data.AD_FUEL.target,
		libraries: state.config.data.AD_FUEL.libraries,
		country: state.client.data.country,
	}), shallowEqual);
	const [isAdFuelNeeded, setAdFuelNeeded] = useState(true);
	const [isAdFuelReady, setAdFuelReady] = useState(false);
	const {pathname} = useLocation();

	const initUserConsent = useCallback(() => {
		if (window.WM && window.WM.UserConsent) {
			window.WM.UserConsent.init({...WMUserConsentConfig, countryCode: country || 'US'});
		}
		return Promise.resolve();
	}, [WMUserConsentConfig, country]);

	useEffect(() => {
		event.on(EVENT_TYPES.AD_INITIALIZATION, setAdFuelNeeded);
		return () => {
			event.off(EVENT_TYPES.AD_INITIALIZATION, setAdFuelNeeded);
		};
	}, []);

	useEffect(() => {
		const setPageLevelTarget = (nbaDetail) => {
			if (isAdFuelReady) {
				if (nbaDetail && nbaDetail.categoryPrimary && nbaDetail.categoryPrimary.adfuelTarget) {
					window.AdFuel.addPageLevelTarget('category', nbaDetail.categoryPrimary.adfuelTarget);
				} else {
					window.AdFuel.removePageLevelTarget('category');
				}
			}
		};
		if (isAdFuelReady && window.AdFuel && pathname.indexOf('/video/') !== 0) {
			setPageLevelTarget();
		}
		event.on(EVENT_TYPES.VIDEO_DETAIL_NBA_FEED_READY, setPageLevelTarget);
		return () => {
			event.off(EVENT_TYPES.VIDEO_DETAIL_NBA_FEED_READY, setPageLevelTarget);
		};
	}, [pathname, isAdFuelReady]);

	useEffect(() => {
		let isMounted = true;
		const initAdFuel = () => {
			if (window.AdFuel && target && isMounted) {
				// window.AdFuel.addPageLevelTarget('status', target);
				setAdFuelReady(true);
			}
		};

		if (isAdFuelNeeded && enabled) {
			try {
				loadScript(WMUserConsentLibrary)
						.then(initUserConsent)
						.then(() => loadScripts(libraries))
						.then(initAdFuel)
						.catch((err) => {
							Logger.warn('useAdInitialization init error:', err);
						});
			} catch (err) {
				Logger.warn('useAdInitialization init error:', err);
			}
		}
		return () => {
			isMounted = false;
		};
	}, [isAdFuelNeeded, enabled, target, libraries, WMUserConsentLibrary, initUserConsent]);
};

export default useAdInitialization;
